// Frontend configuration for environment-based URL switching
// Uses REACT_APP_ENV to determine which server URL to use
// Supports three environments: development, test, production

const env = process.env.REACT_APP_ENV || 'development';

const getServerUrl = () => {
  switch (env) {
    case 'development':
      return 'http://localhost:5050';
    case 'test':
      return 'http://onealigned-001-site6.atempurl.com';
    case 'production':
      return process.env.REACT_APP_SERVER_URL || 'https://www.onealigned.com';
    default:
      return 'http://localhost:5050';
  }
};

const config = {
  serverUrl: getServerUrl()
};

export default config;
